customElements.define("ingredients-section", class Ingredients extends HTMLElement{
    constructor(){
        super()

        this.navigationItems = this.querySelectorAll('.ingredients__navigation-item')
        this.blockSections = this.querySelectorAll('.ingredients__block-wrapper')

        console.log(this.navigationItems)

        this.navigationItems.forEach(item=>item.addEventListener('click', this.onItemClick.bind(this)))

        window.addEventListener("scroll", this.updateNavigation.bind(this))
    }

    onItemClick(event){
        console.log(event.target)
        const relatedItemId = event.target.dataset.relatedBlock
        const relatedBlock = this.querySelector(`#${relatedItemId}`)
        const blockCurrentPosition = relatedBlock.getBoundingClientRect().top + window.scrollY
        
        // this.navigationItems.forEach(item=>item.classList.remove("active"))
        // event.target.classList.add("active")
        
        window.scrollTo({
            top: blockCurrentPosition - 100,
            behavior: "smooth"
        })
    }


    updateNavigation(){
        this.blockSections.forEach(block=>{
            const blockId = block.id
            const blockCurrentPosition = block.getBoundingClientRect().top + window.scrollY - window.innerHeight/2
            if(window.scrollY > blockCurrentPosition && window.scrollY < blockCurrentPosition + 300){
                this.navigationItems.forEach(item=>item.classList.remove("active"))
                this.querySelector(`[data-related-block="${blockId}"]`).classList.add("active")
            }
        })
    }
})